<script setup lang="ts">
import { PrimaryButton, SecondaryButton } from '@/components/Buttons'
import { CardFooter } from '@/components/Cards'
import StackLayout from '@/components/Layouts/StackLayout.vue'
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner.vue'
defineProps<{
    closeLabel?: string
    confirmLabel?: string
    disabled?: boolean
    loading?: boolean
}>()
defineEmits<{
    (e: 'close'): void
    (e: 'confirm'): void
}>()
</script>

<template>
    <CardFooter class="dialog-footer full-width justify-end">
        <StackLayout direction="row" :gap="8" class="dialog-footer-actions">
            <SecondaryButton :label="closeLabel ?? $t('common.cancel')" @click="$emit('close')" />
            <slot />
            <PrimaryButton
                :disabled="loading || disabled"
                :label="confirmLabel ?? $t('common.confirm.confirmAction')"
                @click="$emit('confirm')">
                <LoadingSpinner :isLoading="!!loading" />
            </PrimaryButton>
        </StackLayout>
    </CardFooter>
</template>

<style scoped>
.dialog-footer {
    padding: 0.5em;
    border: unset;
}
.dialog-footer-actions {
    flex-direction: row !important;
}
</style>
